import { MEDIA } from './config/media';

export const CONFIG = {
  PRODUCT_NAME: "BPA Authority Pages",
  BRAND_NAME: "BPA Solutions",
  SUPPORT_EMAIL: "support@bpasolutions.au",
  SUPPORT_PHONE: "0425 228 778",
  BUSINESS_ADDRESS: "81-83 Campbell Street, Surry Hills NSW 2010",
  SYDNEY_HQ: "Sydney HQ: 81-83 Campbell Street, Surry Hills NSW 2010",
  TAGLINE: "Turn Your Website Into a Trust Engine That Brings You Better Clients",
  PRIMARY_CTA: "Request a Quote",
  SECONDARY_CTA: "Preview Live Examples",
  POSITIONING_LINE: "Built for professional service firms and local businesses across Australia, including but not limited to accounting, legal, health, education, care, and lifestyle services.",
  IMAGES: {
    heroBg: {
      url: MEDIA.HERO_HOME.src,
      alt: MEDIA.HERO_HOME.alt
    }
  },
  AU_STATES: ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "ACT", "NT"],
  METROS: ["Sydney", "Melbourne", "Brisbane", "Adelaide", "Perth", "Hobart", "Canberra", "Darwin"],
  INDUSTRIES: [
    "NDIS Disability Support",
    "Accounting & Advisory",
    "Mortgage Broking",
    "Law Firms",
    "Psychology Practices",
    "Allied Health Clinics",
    "Medical Clinics",
    "Driving Schools",
    "Family Day Care",
    "Hair & Beauty Studios",
    "Barber Shops",
    "Education Providers",
    "Business Consulting"
  ],
  SEO: {
    title: "Premium Authority Landing Pages and Professional Websites Sydney | BPA Solutions",
    description: "Sydney based, Australia-wide provider of high-performance, SEO-optimised authority landing pages and professional websites for Australian accountants, lawyers, NDIS providers, and professional firms.",
    keywords: [
      "professional websites Sydney",
      "professional website design Sydney",
      "website design Surry Hills",
      "Sydney landing page design",
      "professional services website Sydney",
      "premium website Sydney",
      "landing page NSW",
      "landing page VIC",
      "landing page QLD",
      "landing page SA",
      "landing page WA",
      "accountant website Australia",
      "law firm website Australia",
      "NDIS provider website",
      "authority marketing",
      "local seo for lawyers"
    ],
    ogTitle: "BPA Authority Pages - Premium Digital Positioning",
    ogDescription: "Build a website that positions you as the obvious choice in your local Australian market."
  },
  REVENUE_RANGES: ["Under $250k", "$250k - $750k", "$750k - $2M", "$2M - $5M", "Over $5M"],
  PRIMARY_GOALS: ["Increase quality enquiries", "Improve local search ranking", "Establish stronger authority", "Replace outdated website"],
  DEMO_SITES: [
    {
      id: "demo-01",
      label: "NextStep Support Services",
      industry: "NDIS Disability Support",
      location: "Logan, QLD",
      url: "https://regal-semifreddo-caa5b4.netlify.app",
      imageUrl: MEDIA.DEMO_1.src,
      alt: MEDIA.DEMO_1.alt,
      description: "Tax & Financial Services Practice"
    },
    {
      id: "demo-02",
      label: "Swan River Accounting",
      industry: "Accounting & Advisory",
      location: "Perth, WA",
      url: "https://enchanting-squirrel-759b61.netlify.app",
      imageUrl: MEDIA.DEMO_2.src,
      alt: MEDIA.DEMO_2.alt,
      description: "Home Loan & Finance Specialist"
    },
    {
      id: "demo-03",
      label: "Adelaide Driving Academy",
      industry: "Driving School",
      location: "Adelaide, SA",
      url: "https://joyful-sundae-156f5f.netlify.app",
      imageUrl: MEDIA.DEMO_3.src,
      alt: MEDIA.DEMO_3.alt,
      description: "Family & Commercial Legal Services"
    },
    {
      id: "demo-04",
      label: "SafeNest Family Day Care",
      industry: "Family Day Care",
      location: "Brisbane, QLD",
      url: "https://amazing-raindrop-72a1c8.netlify.app",
      imageUrl: MEDIA.DEMO_4.src,
      alt: MEDIA.DEMO_4.alt,
      description: "Mental Health & Counselling Clinic"
    },
    {
      id: "demo-05",
      label: "Lexington Legal Group",
      industry: "Law Firm",
      location: "Sydney, NSW",
      url: "https://lexingtonlegalgroup.wlbookings.com/",
      imageUrl: MEDIA.DEMO_5.src,
      alt: MEDIA.DEMO_5.alt,
      description: "Specialist Health & Wellness Center"
    },
    {
      id: "demo-06",
      label: "Luxe Locks Studio",
      industry: "Hair Studio",
      location: "Melbourne, VIC",
      url: "https://deluxehairstudio.wlbookings.com/",
      imageUrl: MEDIA.DEMO_6.src,
      alt: MEDIA.DEMO_6.alt,
      description: "Strategic Business Advisory"
    },
    {
      id: "demo-07",
      label: "Serenity Medical Group",
      industry: "Medical Practice",
      location: "Gold Coast, QLD",
      url: "https://radiologycenter.wlbookings.com/",
      imageUrl: MEDIA.DEMO_7.src,
      alt: MEDIA.DEMO_7.alt,
      description: "Medical Practice"
    },
    {
      id: "demo-08",
      label: "Sharp Edges, Barber Shop",
      industry: "Barber Shop",
      location: "Sydney, NSW",
      url: "https://demosalon.anish-malhotra.com/",
      imageUrl: MEDIA.DEMO_8.src,
      alt: MEDIA.DEMO_8.alt,
      description: "Barber Shop"
    }
  ]
};